
















































































































































































































































































































































































import { Component, Mixins } from 'vue-property-decorator';
import { mapGetters } from 'vuex';
import { Actions, Mutations } from '@/ts/store/Constants';
import DateMethods from '@/mixins/DateMethods.vue';
import TicketHelper from '@/mixins/TicketHelper.vue';
import PreviewTicketImage from '@/components/Admin/Panels/Ticket/PreviewTicketImage.vue';
import NotifyMethods from '@/mixins/NotifyMethods.vue';
import TicketInternalNote from '@/components/Chat/Actions/TicketInternalNote.vue';
import { TICKET_MESSAGE_TYPES } from '@/ts/interfaces/Tickets';
import DeleteMessageAction from '@/components/Overlays/Actions/MessageActions/DeleteMessageAction.vue';
import InputFieldMethods from '@/mixins/InputFieldMethods.vue';

@Component({
    components: {
        PreviewTicketImage,
        TicketInternalNote,
        DeleteMessageAction,
    },
    computed: {
        ...mapGetters({
            ticketAllCategories: 'TicketAttributes/getTicketAllCategories',
            ticketAllTypes: 'TicketAttributes/getTicketAllTypes',
            ticketAllStates: 'Tickets/getTicketAllStates',
            ticketRoleAssignee: 'Tickets/getTicketRoleAssignee',
            ticketImagePreviewVisible: 'Tickets/getTicketImagePreviewVisible',
            ticketSuggestedWatchers: 'Tickets/getTicketSuggestedWatchers',
        }),
    },
})
export default class PreviewTicketInfo extends Mixins(
    DateMethods,
    TicketHelper,
    NotifyMethods,
    InputFieldMethods,
) {
    public newMessageText: string = '';
    public attachedFiles: any[] = [];
    public moreAttachment: boolean = false;
    public moreWatchers: boolean = false;
    public imageToPreview: string = '';
    public watcherSearchQuery: string = '';
    public shownWatchersCount: number = 2;
    public chatMode: string = 'message';

    public showMessageActions: boolean = false;
    public deleteableNoteId: number = null;

    constructor() {
        super();
    }

    get ticketInfo() {
        return this.$store.getters['Tickets/getTicketInfo'];
    }

    get getUserId() {
        return this.$store.getters['User/getUserId'];
    }

    get ticketConversation() {
        return this.$store.getters['Tickets/getTicketsConversation'];
    }

    get ticketConversationMessages() {
        if (this.ticketConversation == null) {
            return [];
        }

        return this.ticketConversation.messages;
    }

    public openMessageActions(noteId: number) {
        this.showMessageActions = true;
        this.deleteableNoteId   = noteId;
    }

    public closeOverlay() {
        this.showMessageActions = false;
        this.deleteableNoteId   = null;
    }

    public deleteMessage() {
        this.$store.dispatch(Actions.DELETE_TICKET_MESSAGE, {
            ticketId: this.ticketInfo.id,
            messageId: this.deleteableNoteId,
        }).then(() => {
            this.closeOverlay();
        });
    }

    public downloadPreviewAttachements() {
        for (const image of this.ticketInfo.images) {
            saveAs(this.setAttacheSrc(image), this.generateStr());
        }
    }

    public generateStr(length: number = 10) {
        let result = '';
        const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        const charactersLength = characters.length;
        for ( let i = 0; i < length; i++ ) {
            result += characters.charAt(Math.floor(Math.random() * charactersLength));
        }
        return result;
    }

    public loadMoreAttachment() {
        this.moreAttachment = !this.moreAttachment;
    }

    public loadMoreWatchers() {
        this.moreWatchers = !this.moreWatchers;
    }

    public attachedFilesThree() {
        if (this.moreAttachment) {
            return this.attachedFiles;
        } else {
            return this.attachedFiles.slice(0, 3);
        }
    }

    public addNewWatcher(id: number) {
        const suggestedWatchers = this.$store.getters['Tickets/getTicketSuggestedWatchers'];
        const newWatcher: any = {};
        const suggestedWatchersFiltered = suggestedWatchers.filter((watcher: any) => {
            if (watcher.id === id) {
                newWatcher.id = watcher.id;
                newWatcher.name = watcher.person ? `${watcher.person.first_name} ${watcher.person.family_name}` : watcher.name;
            }
            return watcher.id !== id;
        });
        this.$store.commit(Mutations.SET_TICKET_SUGGESTED_WATCHERS, suggestedWatchersFiltered);
        this.$store.getters['Tickets/getTicketInfo'].watchers.push(newWatcher);
    }

    public showTicketWatchers(watchers: any) {
        if (this.moreWatchers) {
            return watchers;
        } else {
            return watchers.slice(0, this.shownWatchersCount);
        }
    }

    public refreshAssigneesUsers(categoryId: any) {
        if (categoryId !== '') {
            const currentTicket = this.$store.getters['Tickets/getTicketInfo'];

            currentTicket.assigne_id = '';

            this.$store.dispatch(Actions.FETCH_TICKET_ROLE_ASSIGNEE, { projectId: currentTicket.project_id, categoryId, all: true });
        }
    }

    public removeWatcher(id: number) {
        const currentTicketWatchers = this.$store.getters['Tickets/getTicketInfo'].watchers;
        this.$store.getters['Tickets/getTicketInfo'].watchers = currentTicketWatchers.filter((watcher: any) => {
            return watcher.id !== id;
        });
    }

    public getSuggestedWatchers() {
        const currentTicketWatchers = this.$store.getters['Tickets/getTicketInfo'].watchers;
        const currentTicket = this.$store.getters['Tickets/getTicketInfo'];

        this.$store.dispatch(Actions.FETCH_TICKET_SUGGESTED_WATCHERS, {
            watchers: currentTicketWatchers.map( (watcher: any) => watcher.id),
            search: this.watcherSearchQuery,
            projectId: currentTicket.project_id,
        });
    }

    public hideSuggestedWatchers() {
        this.$store.commit(Mutations.SET_TICKET_SUGGESTED_WATCHERS, []);
        this.watcherSearchQuery = '';
    }

    public previewTicketImageOverlay(image: any) {
        const overlayBody = document.getElementsByClassName('overlay-dialog');
        overlayBody[0].scrollTop = 0;

        this.imageToPreview = image;
        this.$store.commit(Mutations.SET_TICKET_IMAGE_PREVIEW_VISIBILITY, true);
    }

    public getTypeCategories(ev: any) {
        const currentTicket = this.$store.getters['Tickets/getTicketInfo'];

        currentTicket.category_id = '';
        currentTicket.assigne_id  = '';

        this.$store.commit(Mutations.SET_TICKET_ROLE_ASSIGNEE, []);
        this.$store.dispatch(Actions.FETCH_TICKET_ALL_CATEGORIES, {
            projectId: currentTicket.project_id,
            typeId: ev.srcElement.value,
            trash: false,
        });
    }

    public setAttacheSrc(src: string)  {
        return 'data:image/png;charset=utf-8;base64,' + src;
    }

    public returnUsernameFirstLetter(name: string)  {
        return name.charAt(0).toUpperCase();
    }

    public setMessageBlockScroll()  {
        const element = this.$refs.communicationMessages as HTMLElement;
        if (element) {
            element.scrollTop = element.scrollHeight;
        }
    }

    public adminSendNewMessage(conversationId: number)  {
        const currentTicket = this.$store.getters['Tickets/getTicketInfo'];

        if (this.newMessageText.trim() === '') {
            return false;
        }

        this.$store.dispatch(Actions.SEND_MESSAGE_TO_TICKET_USER, {
            ticketId: currentTicket.id,
            conversationId,
            text: this.newMessageText,
            type: this.chatMode === 'note' ? TICKET_MESSAGE_TYPES.TICKET_INTERNAL_NOTE : null,
        });

        this.chatMode = 'message';
        this.newMessageText = '';
        this.setInputFieldHeight(false, true);
    }

    public cancel() {
        this.$store.commit(Mutations.SET_TICKET_INFO_VISIBILITY, false);
        this.$store.dispatch(Actions.RESET_ACTIVE_TICKET_ROWS);
    }

    public editTicket() {
        const currentTicket = this.$store.getters['Tickets/getTicketInfo'];

        if (currentTicket.category_id === '') {
            return this.notify('please_select_the_category', 'warning');
        }

        this.$store.dispatch(Actions.EDIT_CURRENT_TICKET, {
            id: currentTicket.id,
            priority: currentTicket.priority,
            watchers: currentTicket.watchers.map( (watcher: any) => watcher.id),
            assigne_id: currentTicket.assigne_id,
            state_id: currentTicket.state_id,
            category_id: currentTicket.category_id,
            type_id: currentTicket.type_id,
        } );
    }

    public created() {
        this.newMessageText = '';
        const currentTicket = this.$store.getters['Tickets/getTicketInfo'];

        this.$store.dispatch(Actions.FETCH_TICKET_ALL_CATEGORIES, { projectId: currentTicket.project_id, typeId: currentTicket.type_id, trash: false });
        this.$store.dispatch(Actions.FETCH_TICKET_ROLE_ASSIGNEE, { projectId: currentTicket.project_id, categoryId: currentTicket.category_id, all: true });
        this.$store.dispatch(Actions.FETCH_TICKET_ALL_TYPES);
        this.$store.dispatch(Actions.FETCH_TICKET_ALL_STATES);
        this.$store.commit(Mutations.SET_TICKET_SUGGESTED_WATCHERS, []);
        this.$store.commit(Mutations.SET_TICKET_CONVERSATION, { conversation: currentTicket.conversation, scroll: false });
        this.attachedFiles = this.$store.getters['Tickets/getTicketInfo'].images;
    }

    public mounted() {
        this.textInputElement = (this.$refs['message-text'] as HTMLTextAreaElement);
        this.setMessageBlockScroll();
    }
}
